import React, { useContext, useEffect, useState } from 'react'
import Radio, { Option } from '@Components/Fields/Radio'
import Button from '@Components/Buttons/Button'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import { submitReportRequest } from '@App/api/routes/search'
import { ExportType } from '@App/enum/export-type'
import { MatchedRecordingsReportRequestDTO } from '@Entities/report/matched-recordings-report-request'

interface ExportMatchedRecordingsFormProps {
    setIsFormSubmitted: (isFormSubmitted: boolean) => void
}

const ExportMatchedRecordingsForm = (props: ExportMatchedRecordingsFormProps) => {
    const { exportStore, preloaderStore, rightsholderStore, popupStore, workStore } = useContext(StoresContext)

    useEffect(() => {
        // fyi this store call opens the preloader, if more api calls are added then the preloader will need be dealt with
        exportStore.setExportType(ExportType.MATCH_RECORDINGS)
        exportStore.loadExportFormats().then()
    }, [])

    const matchRecordingsReportFormats: Option[] = exportStore.exportFormats
    const [matchRecordingsReportRequest, setmatchRecordingsReportRequest] = useState<MatchedRecordingsReportRequestDTO>(
        { mlcsongCode: workStore.workById?.songCode, format: '' }
    )
    const onFormatChange = (value: Option) => {
        setmatchRecordingsReportRequest({
            ...matchRecordingsReportRequest,
            format: value.value,
        })
    }
    const isFormValid = (): boolean => !!matchRecordingsReportRequest?.format

    const onSubmitCatalogExportRequest = () => {
        if (isFormValid()) {
            preloaderStore.openTransparentPreloader(true)
            const rightsholderId = rightsholderStore.currentRightsholderId
            submitReportRequest(rightsholderId, matchRecordingsReportRequest, ExportType.MATCH_RECORDINGS)
                .then(() => {
                    popupStore.setAlertData('Works Report was Successfully Submitted.', false)
                    props.setIsFormSubmitted(true)
                })
                .finally(() => preloaderStore.openTransparentPreloader(false))
        }
    }

    return (
        <>
            <Radio
                options={matchRecordingsReportFormats}
                field={{ name: 'File Type' }}
                direction="column"
                onChange={onFormatChange}
                title="File Type:"
            />
            <div className="download-button">
                <Button
                    mainColor
                    type="primary"
                    disabled={!isFormValid()}
                    onClick={() => onSubmitCatalogExportRequest()}
                >
                    Download
                </Button>
            </div>
        </>
    )
}

export default observer(ExportMatchedRecordingsForm)
